import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewAnalyticsReport = () => {
    return useQuery({
        queryKey: ['viewAnalyticsReport'],
        queryFn: async () => {
            const res = await api.get('/reports/analytics');
            return res.data?.data;
        }
    });
};  
